module.exports = __webpack_public_path__ + "img/1094one1.f53a9335.png";